import React from 'react';
import {LayoutContainer} from '../../components/LayoutContainer';
import {InformationCard} from './components/InformationCard';

export const MyHospitalizationInformation = () => (
	<LayoutContainer>
		<InformationCard />
	</LayoutContainer>
);
